import type { Nullable } from "../types";
import { guardString } from "./guard-string";

export type Measurement = Nullable<number | string>;

export type MeasurementLabels = {
	width: string;
	height: string;
	depth: string;
};

/**
 * This function takes an object with width, height, and depth properties
 * and returns a string representation of the measurements using provided labels.
 *
 * @param measurements - object with optional width, height, depth
 * @param labels - object defining how to label each dimension
 * @returns a string like "W: 12 x H: 14" (depending on labels)
 */
export function getMeasurementsString(
	measurements: {
		width?: Measurement;
		height?: Measurement;
		depth?: Measurement;
	},
	labels: MeasurementLabels = { width: "W", height: "H", depth: "D" },
): string {
	const { width, height, depth } = measurements;
	const parts: string[] = [];

	if (width !== null && width !== undefined && width !== "")
		parts.push(`${labels.width}: ${width}`);
	if (height !== null && height !== undefined && height !== "")
		parts.push(`${labels.height}: ${height}`);
	if (depth !== null && depth !== undefined && depth !== "")
		parts.push(`${labels.depth}: ${depth}`);

	return parts.join(" x ") || guardString(null);
}
